import styled from "styled-components";

export const DesktopOptionField = styled.div`
  margin-bottom: 16px;
`;
